/**
 * The app's only loading surface: a plain themed ground that knows nothing
 * about the page it precedes, so it can never be wrong about it. Rendered
 * during cold entry and chunk loads; warm navigation paints real content
 * directly and never shows it.
 */
export function RouteGround() {
  return <div className="min-h-full w-full bg-background" data-ground="true" aria-hidden="true" />;
}
